import React from 'react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section className="bg-[#EDF1F5] px-4 py-16 md:py-24" data-id="element-19" data-mp="gwx5x4ldv9es">
      <Reveal className="mx-auto max-w-3xl" data-id="element-20" data-mp="vsmmgn7suuc4">
        <div className="mb-10 text-center md:mb-12" data-id="element-21" data-mp="vuh700f5skfo">
          <div className="inline-flex rounded-full bg-brand-teal/15 px-4 py-2 text-[10px] font-extrabold tracking-[0.14em] text-brand-teal" data-id="element-22" data-mp="qu2wmbq34yeh">
            INCLUDED AT NO EXTRA COST
          </div>
          <h2 className="mt-4 text-3xl font-black text-brand-blue md:text-[2.5rem]" data-id="element-23" data-mp="zurbf8naz2sf">
            5 Exclusive Bonuses for Real Teaching Challenges
          </h2>
        </div>
        <div className="space-y-3" data-id="element-24" data-mp="1elgned8l8lxc">
          {bonuses.map((bonus, index) => {
          const BonusIcon = bonus.icon;
          return <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-brand-blue/[0.07] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-25" data-mp="1njam1uttrrno" data-mpi={index}>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-blue font-serif text-sm font-bold text-white" data-id="element-26" data-mp="3prdeqa35x1x3">
                  {index + 1}
                </span>
                <span className={`flex h-[4.5rem] w-14 shrink-0 flex-col items-center justify-center gap-1 rounded-md text-white shadow-sm sm:h-20 sm:w-[3.75rem] ${bonus.accent}`} aria-hidden="true" data-id="element-27" data-mp="2kkq0lbwr3wz">
                  <BonusIcon className="h-6 w-6" strokeWidth={1.6} data-id="element-28" data-mp="gldpzlkzar7h" />
                  <span className="text-[7px] font-extrabold tracking-[0.1em]" data-id="element-29" data-mp="gjkhe0qt1wwu">BONUS</span>
                </span>
                <div className="min-w-0 flex-1" data-id="element-30" data-mp="le6rm0l5hjfc">
                  <h3 className="text-[15px] font-bold leading-snug text-brand-blue" data-id="element-31" data-mp="qbggnf4mnt2n">{bonus.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-brand-gray" data-id="element-32" data-mp="vbcknedbrki7">{bonus.description}</p>
                  <span className="mt-2 inline-flex rounded-full bg-brand-teal/12 px-2.5 py-1 text-[9px] font-extrabold tracking-[0.1em] text-brand-teal" data-id="element-33" data-mp="10afr938ydysa">
                    INCLUDED
                  </span>
                </div>
              </article>;
        })}
        </div>
      </Reveal>
    </section>;
}